import React from "react";

const detailGroups = [
    {
        title: "Основные реквизиты",
        fields: ["name", "inn", "kpp", "email", "phoneNumber", "ogrn"],
    },
    {
        title: "Адрес",
        fields: ["address", "city", "street", "houseNumber"],
    },
    {
        title: "Оплата",
        fields: ["ndsTypeId", "paymentTypeId"],
    },
];

const displayValue = (value) => (value || value === 0 ? value : "-");

const dictionaryValue = (data, formConfig, enums, name) => {
    const fieldConfig = formConfig[name];
    if (!fieldConfig.dictionary) {
        return data[name];
    }

    const option = (enums[fieldConfig.dictionary] || []).find((item) => `${item.value}` === `${data[name]}`);
    return option?.label || data[name];
};

export default function DetailsView({ data, formConfig, enums, onEdit }) {
    const renderValueField = (name) => (
        <div className="col-sm-6 col-xl-4 mb-3" key={name}>
            <div className="text-muted small">{formConfig[name].label}</div>
            <div>{displayValue(dictionaryValue(data, formConfig, enums, name))}</div>
        </div>
    );

    return (
        <div className="card card-body mb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Реквизиты организации</h5>
                <button className="btn btn-xs btn-secondary" type="button" onClick={onEdit}>
                    Редактировать
                </button>
            </div>
            {detailGroups.map((group) => (
                <div key={group.title} className="mb-2">
                    <div className="font-weight-bold mb-2">{group.title}</div>
                    <div className="row">{group.fields.map(renderValueField)}</div>
                </div>
            ))}
        </div>
    );
}
